/* @flow */
import * as React from 'react';

import AdminUpgradeInformationalPage from 'admin/components/AdminUpgradeInformationalPage';
import Row from 'components/Row';
import AdminUpgradeCompleteButton from 'admin/components/AdminUpgradeCompleteButton';

export default class AdminUpgradeLargeOrganization extends React.Component<{}> {
  render() {
    return (
      <AdminUpgradeInformationalPage
        title="Thanks for your interest!"
        subtext={
          <div>
            <Row size="small">
              Remind provides customized quotes for larger organizations, and a member of our team
              will review your information and contact you to follow up.
            </Row>
            We’re looking forward to talking with you about how a Remind Plan can work for you!
          </div>
        }
        action={<AdminUpgradeCompleteButton />}
      />
    );
  }
}
